import { render, staticRenderFns } from "./ModalRecoveryCodeAlert.vue?vue&type=template&id=7ccd12fe&scoped=true&"
import script from "./ModalRecoveryCodeAlert.vue?vue&type=script&lang=ts&"
export * from "./ModalRecoveryCodeAlert.vue?vue&type=script&lang=ts&"
import style0 from "./ModalRecoveryCodeAlert.vue?vue&type=style&index=0&id=7ccd12fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccd12fe",
  null
  
)

export default component.exports